import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { downloadQuote } from "@/pages/SchoolOffer";

// Admin: open/close the school offer, bank details, quotes list and "virement reçu".
export function AdminSchoolOffer() {
  const [d, setD] = useState(null);
  const load = () => api.get("/admin/school-offer").then(({ data }) => setD(data)).catch(() => setD(false));
  useEffect(() => { load(); }, []);
  if (d === false) return <div className="text-sm text-muted-foreground">Données indisponibles.</div>;
  if (!d) return null;
  const save = async (patch) => {
    try { await api.put("/admin/school-offer", { enabled: d.enabled, iban: d.iban, bic: d.bic, ...patch }); toast.success("Offre établissement enregistrée."); load(); }
    catch (err) { toast.error(err?.response?.data?.detail || "Enregistrement impossible."); }
  };
  const paid = async (q) => {
    if (!window.confirm(`Confirmer la réception du virement de ${q.amount.toFixed(2)} € (${q.number}) ? ${q.credits} crédits seront ajoutés à ${q.email}.`)) return;
    try { await api.post(`/admin/school-quotes/${q.id}/paid`); toast.success("Crédits ajoutés et facture envoyée."); load(); }
    catch (err) { toast.error(err?.response?.data?.detail || "Action impossible."); }
  };
  return (
    <div className="space-y-4" data-testid="admin-school-offer">
      <label className="flex items-center gap-2 text-sm">
        <input type="checkbox" checked={d.enabled} disabled={!d.has_siret} onChange={(e) => save({ enabled: e.target.checked })} data-testid="admin-school-offer-toggle" />
        Offre ouverte au public (page /etablissements/devis)
      </label>
      {!d.has_siret && <p className="text-[12px] text-[#FF2A00]">Ajoutez d'abord votre SIRET dans « Infos légales » pour pouvoir ouvrir l'offre.</p>}
      <div className="grid sm:grid-cols-[1fr_160px_auto] gap-2">
        <input className="border border-border bg-background px-3 py-2 text-sm" placeholder="IBAN (pour les virements)" value={d.iban} onChange={(e) => setD({ ...d, iban: e.target.value })} data-testid="admin-school-iban" />
        <input className="border border-border bg-background px-3 py-2 text-sm" placeholder="BIC" value={d.bic} onChange={(e) => setD({ ...d, bic: e.target.value })} data-testid="admin-school-bic" />
        <button type="button" onClick={() => save({})} className="px-4 py-2 bg-[#002FA7] text-white text-sm" data-testid="admin-school-save">Enregistrer</button>
      </div>
      <div className="divide-y divide-border border border-border" data-testid="admin-school-quotes">
        {!d.quotes.length && <div className="p-3 text-sm text-muted-foreground">Aucun devis pour l'instant.</div>}
        {d.quotes.map((q) => (
          <div key={q.id} className="p-3 flex flex-wrap items-center justify-between gap-2 text-sm">
            <span><b>{q.number}</b> · {q.created_at?.slice(0, 10)} · {q.school} · {q.email} · {q.credits} crédits · {q.amount.toFixed(2)} € · {q.method}</span>
            <span className="flex items-center gap-2">
              <button type="button" onClick={() => downloadQuote(q.id, q.number)} className="underline text-[12px]">PDF</button>
              {q.status === "paid" ? <span className="text-[#0A8F5A] font-bold text-[12px]">Payé</span> : q.method === "carte" ? <span className="text-[12px] text-muted-foreground">En attente (carte)</span> : (
                <button type="button" onClick={() => paid(q)} className="px-3 py-1 border border-[#002FA7] text-[#002FA7] text-[12px]" data-testid={`admin-school-paid-${q.number}`}>Virement reçu</button>
              )}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AdminSchoolOffer;
